import { Inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { ListStateService } from '@modules/common/components/list/list-state.service';
import { SortBy } from '@modules/common/types/SortBy';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { StateService } from '@modules/settings/services/state.service';
import { StateKey } from '@modules/settings/types/state-key';
import { Sheet } from '../types/sheet';
import { SheetFoldersListSortField, SheetFoldersListState } from '../types/sheet-folders-list-state';

export interface SheetFolderListStateServiceConfig {
  stateKey?: StateKey;
  withAdvancedSearch?: boolean;
  defaultSort?: SortBy<SheetFoldersListSortField>;
}

export const SheetFolderListStateServiceConfigToken = new InjectionToken<SheetFolderListStateServiceConfig>(
  'Configuration object for sheet-folder list state service',
);

@Injectable()
export class SheetFolderListStateService extends ListStateService<Sheet, SheetFoldersListSortField, SheetFoldersListState> {
  declare public readonly state: SheetFoldersListState;

  constructor(
    stateService: StateService,
    advancedSearchService: AdvancedSearchService,
    @Inject(SheetFolderListStateServiceConfigToken) config: SheetFolderListStateServiceConfig,
  ) {
    super();

    this.state = new SheetFoldersListState({
      searchService: advancedSearchService,
      stateService: stateService,
      stateKey: config.stateKey,
      withAdvanced: config.withAdvancedSearch,
      defaultSort: config.defaultSort,
    });
  }

  public static providers(config: SheetFolderListStateServiceConfig = {}): Provider[] {
    return super.prepareProviders(SheetFolderListStateServiceConfigToken, config);
  }
}

declare module '@modules/settings/types/state' {
  export interface State {
    [StateKey.sheetFoldersListState]?: SheetFoldersListState;
    [StateKey.sidebarSheetFoldersListState]?: SheetFoldersListState;
    [StateKey.sheetFoldersDPListState]?: SheetFoldersListState;
  }
}
